import React from 'react';

const Instagram = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 16.1559C14.0711 16.1559 15.75 14.477 15.75 12.4059C15.75 10.3348 14.0711 8.65588 12 8.65588C9.92893 8.65588 8.25 10.3348 8.25 12.4059C8.25 14.477 9.92893 16.1559 12 16.1559Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.125 3.78088H7.875C5.38972 3.78088 3.375 5.7956 3.375 8.28088V16.5309C3.375 19.0162 5.38972 21.0309 7.875 21.0309H16.125C18.6103 21.0309 20.625 19.0162 20.625 16.5309V8.28088C20.625 5.7956 18.6103 3.78088 16.125 3.78088Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      // fill="none"
      d="M16.875 8.46838C17.3928 8.46838 17.8125 8.04865 17.8125 7.53088C17.8125 7.01312 17.3928 6.59338 16.875 6.59338C16.3572 6.59338 15.9375 7.01312 15.9375 7.53088C15.9375 8.04865 16.3572 8.46838 16.875 8.46838Z"
      fill="#3F3C43"
    />
  </svg>
);

export default Instagram;
